import React from "react";

const GooglePlay = ({ ...rest }) => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g id="logo-googleplay">
        <path
            id="Vector"
            d="M5.75 19.9472V4.78123C5.75 3.41022 7.3133 2.5549 8.56069 3.24291L22.2995 10.8259C22.5805 10.9727 22.816 11.1937 22.9803 11.4649C23.1446 11.7361 23.2314 12.0472 23.2314 12.3642C23.2314 12.6813 23.1446 12.9923 22.9803 13.2635C22.816 13.5347 22.5805 13.7557 22.2995 13.9026L8.56194 21.4856C7.3133 22.1748 5.75 21.3183 5.75 19.9472Z"
            stroke="currentColor"
            strokeWidth="1.33"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <mask
            id="mask0_1176_859"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="5"
            y="3"
            width="19"
            height="19"
        >
            <path
                id="Mask"
                d="M5.75 19.9472V4.78123C5.75 3.41022 7.3133 2.5549 8.56069 3.24291L22.2995 10.8259C22.5805 10.9727 22.816 11.1937 22.9803 11.4649C23.1446 11.7361 23.2314 12.0472 23.2314 12.3642C23.2314 12.6813 23.1446 12.9923 22.9803 13.2635C22.816 13.5347 22.5805 13.7557 22.2995 13.9026L8.56194 21.4856C7.3133 22.1748 5.75 21.3183 5.75 19.9472Z"
                fill="black"
            />
        </mask>
        <g mask="url(#mask0_1176_859)">
            <g id="Vector_2">
                <path d="M6.3291 3.49854L15.5066 11.9643L19.3649 15.523" fill="currentColor" />
                <path
                    d="M6.3291 3.49854L15.5066 11.9643L19.3649 15.523"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                id="Vector_3"
                d="M6.29199 21.1794L15.507 11.9644L18.6536 8.81787"
                stroke="currentColor"
                strokeWidth="1.33"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </g>
</svg>
    );
};

export default GooglePlay;
